import { render, staticRenderFns } from "./ExtractDetail.vue?vue&type=template&id=31e3e38d&scoped=true&"
import script from "./ExtractDetail.vue?vue&type=script&lang=js&"
export * from "./ExtractDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExtractDetail.vue?vue&type=style&index=0&id=31e3e38d&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e3e38d",
  null
  
)

export default component.exports